﻿import { store } from "@redux/store";
import eventTrackingSlice from "../redux/slices";

const actions = eventTrackingSlice.actions;

const dispatchEvent = (event) => {
    event.eventType = "tdvEvent";
    document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
        detail: { data: event }
    }));
    store.dispatch(actions.trackingEventFulfilled());
};

export default dispatchEvent;